import React from "react";
import EmptyIcon from "../../../images/orders/empty.svg"
const EmptyPositions = () => {
  return (
    <div className="px-[60px] bg-p400">
      <div className="h-[630px] flex flex-col items-center justify-center">
        <img src={EmptyIcon} alt="Empty State Icon" className="w-24 h-24" />
        <div className="h-5" />
        <p className="text-[16px] font-semibold text-p300">
          You don’t have any positions
        </p>
        <div className="h-2.5" />
        <p className="text-[14px] font-semibold text-n500 text-center w-72">
          Currently there isn’t any positions available in your profile. You can
          explore and add the positions from Builder
        </p>
      </div>
    </div>
  );
};

export default EmptyPositions;
